import { render, staticRenderFns } from "./dateRangePicker.template?vue&type=template&id=63b61bef&lang=pug&"
import script from "./dateRangePicker.client?vue&type=script&lang=ts&"
export * from "./dateRangePicker.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b61bef')) {
      api.createRecord('63b61bef', component.options)
    } else {
      api.reload('63b61bef', component.options)
    }
    module.hot.accept("./dateRangePicker.template?vue&type=template&id=63b61bef&lang=pug&", function () {
      api.rerender('63b61bef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/dateRangePicker/dateRangePicker.component.vue"
export default component.exports